/**
 * Парсить рядок розкладу роботи
 * Формат: "Пн.-Пт.:07:00-16:00 Сб.:08:00-14:00 Нд.:08:00-14:00"
 * @param {string} hWork - Рядок годин роботи
 * @param {string} zWork - Рядок обідньої перерви
 * @returns {Object} Об'єкт з розкладом
 */
export const parseSchedule = (hWork, zWork) => {
    if (!hWork) {
        return {
            weekdays: { start: '-', lunch: '-', end: '-' },
            saturday: 'вихідний',
            sunday: 'вихідний'
        };
    }

    const hParts = hWork.split('.:');
    const zParts = zWork ? zWork.split('.:') : [];

    const weekdayTime = hParts[1] ? hParts[1].replace(/\s*Сб.*$/, '').trim() : '';
    const weekdayZ = zParts[1] ? zParts[1].replace(/\s*Сб.*$/, '').trim() : '';

    const saturdayTime = hParts[2] ? hParts[2].replace(/\s*Нд.*$/, '').trim() : '';
    const saturdayZ = zParts[2] ? zParts[2].replace(/\s*Нд.*$/, '').trim() : '';

    const sundayTime = hParts[3] ? hParts[3].trim() : '';
    const sundayZ = zParts[3] ? zParts[3].trim() : '';

    const isSaturdayClosed = !saturdayTime || saturdayTime === '-' ||
        saturdayTime.toLowerCase().includes('вихідний') ||
        saturdayTime === '--' || saturdayTime === '---';

    const isSundayClosed = !sundayTime || sundayTime === '-' || sundayTime === '--' ||
        sundayTime === '---' || sundayTime.toLowerCase().includes('вихідний');

    return {
        weekdays: {
            start: weekdayTime.split('-')[0] || '-',
            lunch: weekdayZ.split('-')[1] || '-',
            end: weekdayTime.split('-')[1] || '-',
        },
        saturday: isSaturdayClosed ? 'вихідний' : {
            start: saturdayTime.split('-')[0] || '-',
            lunch: saturdayZ.split('-')[1] || '-',
            end: saturdayTime.split('-')[1] || '-',
        },
        sunday: isSundayClosed ? 'вихідний' : {
            start: sundayTime.split('-')[0] || '-',
            lunch: sundayZ.split('-')[1] || '-',
            end: sundayTime.split('-')[1] || '-',
        }
    };
};

/**
 * Отримує список сервісів пункту
 * @param {string|Array} opt - Рядок з опціями або масив
 * @returns {Array} Масив ідентифікаторів сервісів
 */
export const parseServices = (opt) => {
    if (!opt) return [];
    if (Array.isArray(opt)) return opt;
    return opt.replace(/{|}/g, '').split(',').map(s => s.trim()).filter(Boolean);
};

/**
 * Витягує значення завантаження з opt
 * @param {string|Array} opt - Рядок з опціями або масив
 * @returns {number} Завантаження від 0 до 100
 */
export const extractLoad = (opt) => {
    if (!opt) return 60;

    const optStr = Array.isArray(opt) ? opt.join(',') : opt;
    const loadMatch = optStr.match(/load(\d+)/);
    if (loadMatch && loadMatch[1]) {
        return parseInt(loadMatch[1], 10);
    }

    return 60;
};

/**
 * Форматує адресу, видаляючи частину з містом
 * @param {string} address - Повна адреса
 * @returns {string} Форматована адреса
 */
export const formatAddress = (address) => {
    if (!address) return '';
    const withoutCity = address.replace(/^(м\.|смт|с\.)\s*[^,]+,\s*/, '');
    return withoutCity.trim();
};
